import _ from 'underscore';
import { Scopes } from '@bingads-webui-campaign-react/goal-selector';

export const getConversionGoalTitleDetails = (i18n, conversionGoals = {}) => {
  const {
    goalScopeSelection,
    goalSelection,
  } = conversionGoals;

  if (goalScopeSelection === Scopes.CAMPAIGN && _.size(goalSelection) > 0) {
    const goalNames = _.pluck(goalSelection, 'Name');

    return goalNames.join(', ');
  }

  return i18n.getString(_TL_('Use account settings'));
};
